import { render } from "./B2bFiltersAccountingCloseDraft.vue?vue&type=template&id=9b65caf0&scoped=true&lang=pug"
import script from "./B2bFiltersAccountingCloseDraft.vue?vue&type=script&lang=js"
export * from "./B2bFiltersAccountingCloseDraft.vue?vue&type=script&lang=js"

import "./B2bFiltersAccountingCloseDraft.vue?vue&type=style&index=0&id=9b65caf0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b65caf0"]])

export default __exports__